import React, { useContext } from "react";
import quizHeroCards from "./quiz-hero-cards.json";
import { SectionContext } from "./../context";
import { ATTRIBUTION_PARAM } from "../snowflake/navigation";
import { ArrowRight } from "../../icon/arrow-left";
import { SiteContext } from "../../global/site-context";

// Trading Card Component
const TradingCard = ({ card, index }) => {
  const site = useContext(SiteContext);
  const horizontalOffset = (card.horizontalOffset || 0) * (site.isLarge ? 1 : site.isNotMobile ? 0.5 : 0.3);
  const delayClasses = ['animate-orbit', 'animate-orbit-delay-1', 'animate-orbit-delay-2', 'animate-orbit-delay-3', 'animate-orbit-delay-4', 'animate-orbit-delay-5'];
  const animationClass = delayClasses[index] || 'animate-orbit';

  return (
    <div className="relative flex justify-center" style={{ transform: `translateX(${horizontalOffset}px)` }}>
      <div className={animationClass}>
        {/* Main card */}
        <div
          className="group relative h-full rounded-lg transform transition-size duration-300 hover:scale-105"
          style={{
            width: '146px',
            height: '214px',
            zIndex: 50,
            borderColor: card.color,
            backgroundColor: card.color,
            borderWidth: '3px',
            transform: `rotate(${card.rotation}deg)`,
            boxShadow: `0 0 50px ${card.color}40`,
            filter: 'drop-shadow(0 0 20px ' + card.color + '40)'
          }}
        >
          {/* Background Image - fills entire card */}
          <div
            className="absolute inset-0 bg-center bg-no-repeat rounded-lg"
            style={{
              backgroundImage: `url(/static/img/quiz/${card.fileName})`,
              backgroundSize: 'cover',
              zIndex: 1
            }}
          />

          {/* Main Content - Center */}
          <div

            className="absolute bottom-0 right-0 z-10 flex flex-col justify-center p-3 text-right opacity-30 group-hover:opacity-100 transition-opacity duration-500"
          >
            <h3 className="text-white font-superheroBold text-lg mb-0.5 leading-tight max-w-2/3 ml-auto drop-shadow-md"
              style={{ lineHeight: '1', textShadow: '0 0 4px rgba(0, 0, 0, 0.8)' }}>
              {card.name}
            </h3>
            <p className="text-light-80 drop-shadow-md" style={{ fontSize: '10px', lineHeight: '12px' }}>
              {card.jobTitle}
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};

// Quiz Hero Section
export const QuizHero = ({ section }) => {
  const cards = quizHeroCards.cards;
  const leftCards = cards.slice(0, 3);
  const rightCards = cards.slice(3, 6);

  return (
    <SectionContext.Provider value={{ isDarkBg: true }}>
      <div className="max-w-6xl mx-auto px-4 -mt-12 pt-12 overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-hero-quiz gap-8 md:gap-0 items-center">

          {/* Left Cards */}
          <div className="flex flex-col" style={{ gap: '-40px' }}>
            {leftCards.map((card, index) => (
              <div key={index} style={{ marginTop: index > 0 ? '-40px' : '0' }}>
                <TradingCard card={card} index={index} />
              </div>
            ))}
          </div>

          {/* Center Content */}
          <div className="text-center lg:px-6">
            <div className="text-white font-openSans mb-8">
              <h2 className="font-superhero font-light text-2xl italic uppercase mb-4">
                Right <span className="font-medium">Person.</span>{" "}
                Right <span className="font-medium">time.</span>{" "}
                Right <span className="font-medium">Message.</span>
              </h2>
              <h1 className="font-superhero tracking-wide uppercase italic text-6xl lg:text-9xl" style={{ fontWeight: '700' }}>
                AI superpowers<br />for GTM heroes
              </h1>
              <h3 className="font-openSans text-light-70 mt-4 max-w-md mx-auto">
                Pipegen is harder than ever—but our customers are cutting through the noise and connecting with relevance every time.
              </h3>
            </div>

            <div className="space-y-4 relative z-10">
              <div>
                <a
                  href="#quiz"
                  className="inline-block bg-superhero-link font-semibold text-black rounded-lg hover:text-dark-80 px-6 py-3 transform scale-100 hover:scale-105 transition-all duration-300"
                  style={{
                    boxShadow: '1px 1px 34px 4px rgba(34, 216, 153, 0.25)',
                  }}
                >
                  Unlock your GTM superpowers
                </a>
              </div>
              <div>
                <a
                  href={`/demo/?${ATTRIBUTION_PARAM}=hero-quiz`}
                  className="inline-block text-white bg-gray-1000 border border-light-60 rounded-lg hover:text-white hover:border-white px-4 py-2 transform scale-100 hover:scale-105 transition-all duration-300"
                >
                  Request demo
                </a>
              </div>
            </div>
          </div>

          {/* Right Cards */}
          <div className="flex flex-col mt-10 lg:mt-0">
            {rightCards.map((card, index) => (
              <div key={index} style={{ marginTop: index > 0 ? '-40px' : '0' }}>
                <TradingCard card={card} index={index + 3} />
              </div>
            ))}
          </div>

        </div>
      </div>
    </SectionContext.Provider>
  );
};

export { TradingCard };